//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SameProductCard',
  props: {
    sameProduct: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    isProfitable: function() {
      let profitChar = null;
      const _sameProduct = this.sameProduct;
      profitChar = _sameProduct.characteristics?.[0]?.characteristics.find((item) => {
        return Boolean(item.name === 'items_in_pack_diff');
      })
      if (profitChar) {
        const profitCharValue = Number.parseFloat(profitChar.values?.[0]?.value);
        if (profitCharValue > 0 && profitCharValue < 1) {
          return (100 - profitCharValue * 100);
        } else return false
      }
      return false
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat("ru-RU").format(price);
    }
  }
}
